export const setTeamInfo = (teamInfo) => ({
  type: "SET_TEAM_INFO",
  payload: teamInfo,
});

export const setPlayerStats = (info) => ({
  type: "SET_PLAYER_STATS",
  payload: info,
});
